export const normalizeOptionValue = (value: string | number) => String(value);

export const toStringArray = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (typeof item === 'number') {
          return String(item);
        }
        if (typeof item === 'string') {
          return item;
        }
        return null;
      })
      .filter((item): item is string => typeof item === 'string' && item.length > 0);
  }
  if (typeof value === 'number') {
    return [String(value)];
  }
  if (typeof value === 'string' && value.length > 0) {
    return [value];
  }
  return [];
};
